import { TASK_STATUSES } from "@miplatform/constants";
import { MiTHEME } from "@miplatform/theme";

export const getStatusStyle = (status) => {
  switch (status) {
    case TASK_STATUSES.FINALIZED:
      return {
        color: MiTHEME.palette.green.main,
        backgroundColor: MiTHEME.palette.green.light,
      };
    case TASK_STATUSES.IN_PROGRESS:
      return {
        color: MiTHEME.palette.orange.main,
        backgroundColor: MiTHEME.palette.orange.light,
      };
    default:
      return {
        color: MiTHEME.palette.common.black,
        backgroundColor: MiTHEME.palette.grey.lightAccent,
      };
  }
};
